import { render } from "./LayOut.vue?vue&type=template&id=9638407c"
import script from "./LayOut.vue?vue&type=script&lang=js"
export * from "./LayOut.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__